const DEFAULT_OFFSET = 75
const RADIX = 10
const TO_PERCENT = 100

const enter = viewport => {
  // cache top level nodes and offsets
  let sections = Array.from(document.querySelectorAll('[data-inview]')).map(element => ({
    node: element,
    offset: element.hasAttribute('data-offset')
      ? parseInt(element.getAttribute('data-offset'), RADIX)
      : DEFAULT_OFFSET
  }))

  // return a function that adds inview class, based on viewport
  return () => {
    const entered = sections.filter(config => {
      // node bounding rect
      const bounds = config.node.getBoundingClientRect()

      // check if in viewport
      return bounds.top < viewport.height * (config.offset / TO_PERCENT)
    })

    // remove from sections array
    sections = sections.filter(config => entered.indexOf(config) < 0)

    entered.forEach(config => {
      config.node.classList.add('is-inview')
    })
  }
}

export default enter
